import { render, staticRenderFns } from "./ModalVideobox.vue?vue&type=template&id=4107883a&scoped=true&"
import script from "./ModalVideobox.vue?vue&type=script&lang=js&"
export * from "./ModalVideobox.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideobox.vue?vue&type=style&index=0&id=4107883a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4107883a",
  null
  
)

export default component.exports